import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { fetchConfig } from "utils";

const useGetLandingPageStats = () => {
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		const instance = await InitApi({ accessToken, apiVersion: "v2" });
		const res = await instance.get("landing-page-stats");
		return res.data?.data;
	};

	return useQuery(["landing-page-stats"], () => fetch(), {
		...fetchConfig,
	});
};

export default useGetLandingPageStats;
